import React from 'react';
import ErrorPage from './ErrorPage';
import { func, shape, string } from 'prop-types';
import useStandardErrorButtons from './useStandardErrorButtons';

export default function GraphQLErrorPage({ onClickReset, error }) {
  const buttons = useStandardErrorButtons(onClickReset);
  const errorMessage = `${error.message}. ${error.networkError.name} - ${error.networkError.result?.errors
    ?.map((e) => `${e.message}`)
    .join(', ')}`;

  return <ErrorPage message={errorMessage} buttons={buttons} />;
}

GraphQLErrorPage.propTypes = {
  onClickReset: func,
  error: shape({ message: string }),
};
